module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-content-wrapper"
  }, [_c('div', {
    staticClass: "container-fluid container-fixed-lg"
  }, [_c('div', {
    staticClass: "panel panel-transparent"
  }, [_c('page-title', {
    attrs: {
      "title": _vm.$t('contaBancaria.titulos.contasBancarias'),
      "subTitle": _vm.$t('contaBancaria.labels.visualizacao')
    }
  }, [_c('button-primary', {
    staticClass: "pull-right",
    attrs: {
      "slot": "new-button",
      "label": _vm.$t('contaBancaria.labels.novaConta'),
      "id": "btnNovaContaBancaria",
      "clickFunction": _vm.newBankAccount
    },
    slot: "new-button"
  })], 1), _c('div', {
    attrs: {
      "id": "accounts"
    }
  }, [_c('v-client-table', {
    staticClass: "data-table custom-data-table",
    attrs: {
      "data": _vm.bankAccounts,
      "columns": _vm.columns,
      "options": _vm.options
    },
    scopedSlots: _vm._u([{
      key: "acoes",
      fn: function(props) {
        return [(_vm.isLoadingData) ? _c('loading-placeholder') : _vm._e(), (!_vm.isLoadingData) ? _c('div', {
          staticClass: "actions"
        }, [_c('button', {
          staticClass: "fa fa-pencil action",
          attrs: {
            "title": _vm.$t('contaBancaria.labels.editar')
          },
          on: {
            "click": function($event) {
              return _vm.edit(props.row.id)
            }
          }
        }), _c('button', {
          staticClass: "fa fa-times action",
          attrs: {
            "disabled": props.row.contaEmUso,
            "title": props.row.contaEmUso ? _vm.$t('contaBancaria.labels.deleteBloqueado') : _vm.$t('contaBancaria.labels.delete')
          },
          on: {
            "click": function($event) {
              return _vm.handleRemove(props.row.id)
            }
          }
        })]) : _vm._e()]
      }
    }])
  }, [_c('template', {
    slot: "filter__banco"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'banco')
      }
    }
  })]), _c('template', {
    slot: "filter__agencia"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'agencia')
      }
    }
  })]), _c('template', {
    slot: "filter__conta"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'conta')
      }
    }
  })]), _c('template', {
    slot: "filter__status"
  }, [_c('input', {
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    on: {
      "input": function($event) {
        return _vm.handleFilter($event, 'status')
      }
    }
  })])], 2)], 1)], 1)]), _c('confirm-modal', {
    attrs: {
      "id": "confirmRemoveBankAccount"
    }
  }, [_c('div', {
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-xs-12 row-filter-small confirm-text",
    domProps: {
      "innerHTML": _vm._s(_vm.$t('contaBancaria.labels.confirmarDelete'))
    }
  })]), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button-primary', {
    staticClass: "confirm-buttom",
    attrs: {
      "label": _vm.$t('remessaIntegracao.labels.nao'),
      "customClass": "secondary",
      "id": "btnFecharModalRemoverBankAccount",
      "clickFunction": _vm.closeModalConfirm
    }
  }), _c('button-primary', {
    staticClass: "pull-right confirm-buttom",
    attrs: {
      "disabled": _vm.requestSentRemove,
      "label": _vm.$t('remessaIntegracao.labels.sim'),
      "id": "btnConfirmarModalRemoverBankAccount",
      "clickFunction": _vm.remove
    }
  })], 1)])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-743a74ea", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-743a74ea"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./client/components/views/registration/bankAccounts/list.pug
// module id = 1437
// module chunks = 0